<div class="form-wrapper" [formGroup]="assessmentForm">
  <div class="form-header mat-h3">AI Assessment Wizard</div>
  <div class="form">
    <div class="quiz-container-fluid">
      <div class="line">
        <mat-form-field floatLabel="always" class="assessment-title">
          <mat-label>Assessment title</mat-label>
          <input matInput formControlName="title">
        </mat-form-field>
      </div>
      <div class="line">
        <mat-form-field appearance="outline" floatLabel="always" class="assessment-description">
          <mat-label>Description</mat-label>
          <textarea matInput formControlName="description" cdkTextareaAutosize></textarea>
        </mat-form-field>
      </div>
      <div class="criteria-header">Criteria:</div>
      <div *ngFor="let criteria of assessment.criterias" class="criteria-form-container">
        <assessment-criteria-form [criteria]="criteria" (update)="updateCriteria($event)" (delete)="deleteCriteria($event)" [deleteEnabled]="assessment.criterias.length > MIN_CRITERIA"></assessment-criteria-form>
      </div>
      <button class="add-button" mat-button (click)="addCriteria()" [disabled]="assessment.criterias.length >= MAX_CRITERIA">
        <mat-icon>add_circle</mat-icon>
        <span>New Criteria</span>
      </button>
    </div>
  </div>
  <div class="bottom-buttons">
    <button mat-button color="primary" (click)="_dialogRef.close()">CANCEL</button>
    <button mat-flat-button color="primary" (click)="saveAndClose()">SAVE ASSESSMENT</button>
  </div>
</div>
